import {  useState } from "react";
import { Form, Button} from 'reactstrap';
import { APIMS } from "../../../../../../config/apims";
import Modal from 'react-bootstrap/Modal';
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import "../../../../../../index.css";
import ToastError from "../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';


const css = `
.range-info-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.range-info-item {
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 14px 16px;
  background: #f9fbfd;
  transition: all 0.2s ease;
}

.range-info-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.range-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.range-score {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}

.range-badge {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.3px;
  background: #e5e7eb;
  color: #111827;
}

.range-desc {
  margin-top: 8px;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
}

/* aksen tiap kategori */
.range-info-item.amt {
  border-left: 5px solid #ef4444;
}

.range-info-item.amt .range-badge {
  background: #fee2e2;
  color: #b91c1c;
}

.range-info-item.act {
  border-left: 5px solid #f59e0b;
}

.range-info-item.act .range-badge {
  background: #fef3c7;
  color: #b45309;
}

.range-info-item.at {
  border-left: 5px solid #3b82f6;
}

.range-info-item.at .range-badge {
  background: #dbeafe;
  color: #1d4ed8;
}

.range-info-item.ast {
  border-left: 5px solid #10b981;
}

.range-info-item.ast .range-badge {
  background: #d1fae5;
  color: #047857;
}
`

export default function InfoRangePenilaian(props) {
  const token = localStorage.getItem("token");
  const [propsData, setProopsData] = useState();
  

  return (
  <div className="modal">
     <style>{css}</style>

     <Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" centered backdrop="static" keyboard={false}>  
    
          <div className="d-flex header-modal">
            {/* <h5>Keterangan Range Nilai</h5> */}
            <div className="ml-auto x-close">
              <FontAwesomeIcon icon={faXmark} onClick={() => setProopsData(props.onHide)} />
            </div>
          </div>
          <hr/>
    
          {/* <Modal.Body className="modal-body">
            <div className="mt-3">
                <p> 1.00 – 2.49 = AMT (Adab Mulai Terpuji) </p>
                <p> 2.50 – 2.99 = ACT (Adab Cukup Terpuji) </p>
                <p> 3.00 – 3.49 = AT (Adab Terpuji) </p>
                <p> 3.50 – 4.00 = AST (Adab Sangat Terpuji) </p>
            </div>
          </Modal.Body> */}

          <Modal.Body className="modal-body mb-3">
            <div className="mb-3">
    <h6 className="mb-1 fw-bold">Klasifikasi Nilai KKCA</h6>
    <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
      Berikut keterangan range nilai beserta predikatnya.
    </p>
  </div>
  <div className="range-info-list">
    <div className="range-info-item amt">
      <div className="range-top">
        <span className="range-score">1.00 – 2.49</span>
        <span className="range-badge">AMT</span>
      </div>
      <div className="range-desc">Adab Mulai Terpuji</div>
    </div>

    <div className="range-info-item act">
      <div className="range-top">
        <span className="range-score">2.50 – 2.99</span>
        <span className="range-badge">ACT</span>
      </div>
      <div className="range-desc">Adab Cukup Terpuji</div>
    </div>

    <div className="range-info-item at">
      <div className="range-top">
        <span className="range-score">3.00 – 3.49</span>
        <span className="range-badge">AT</span>
      </div>
      <div className="range-desc">Adab Terpuji</div>
    </div>

    <div className="range-info-item ast">
      <div className="range-top">
        <span className="range-score">3.50 – 4.00</span>
        <span className="range-badge">AST</span>
      </div>
      <div className="range-desc">Adab Sangat Terpuji</div>
    </div>
  </div>
</Modal.Body>
    </Modal>

    </div> 
  );
}
  